import Image from 'next/image';

import { Box, Heading, Text } from '@chakra-ui/react';

import { CaseStudyTestimonial } from '../models/case-study-content';

export function TestimonialCard({ testimonial }: { testimonial: CaseStudyTestimonial }) {
  return (
    <Box
      as='section'
      backgroundColor='accent.sky.100'
      borderColor='blue.500'
      borderLeftWidth='3px'
      borderStyle='solid'
      padding='32px'
    >
      <Text fontSize='24px' lineHeight='34px'>{`"${testimonial.quote}"`}</Text>

      <Box alignItems='center' display='flex' marginTop='24px'>
        <Box borderRadius='64px' marginRight='16px' overflow='hidden'>
          <Image alt='Company Logo' height={64} src={testimonial.profileImage.asset.url} width={64} />
        </Box>

        <Box>
          <Heading as='p' size='marketing-lg'>
            {testimonial.name}
          </Heading>

          <Text fontSize='14px'>{testimonial.title}</Text>
        </Box>
      </Box>
    </Box>
  );
}
